<template>
  <div
    v-if="cueHtml"
    class="vp-subtitle-overlay"
    role="status"
    aria-live="polite"
    :aria-label="t('player.accessibility.subtitles')"
  >
    <!-- eslint-disable-next-line vue/no-v-html -- Safe: content from browser VTT parser (getCueAsHTML) -->
    <span class="vp-subtitle-text" v-html="cueHtml"></span>
  </div>
</template>

<script setup lang="ts">
import { useVideoI18n } from '../../i18n'

defineProps<{
  cueHtml: string
}>()

const { t } = useVideoI18n()
</script>
